export const logout = async () => {
  const response = await fetch(
    `${import.meta.env.VITE_FRONTIER_CONNECT_URL}/raystack.frontier.v1beta1.FrontierService/AuthLogout`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({}),
      credentials: 'include'
    }
  );

  if (!response.ok) {
    throw new Error('Logout failed');
  }

  return response.json();
};
